export class Updateuser {

    public firstname : string ;
    public lastname : string ;
    public usertype : number ;
    public access : string ; 
    public username : string;
    public status : boolean ;
    public userId : number;
    public roleId : number;
    
    public password : string;
    public confpassword : string;
    public teststr : string;
    public selectedlocations : any[];
    
        
    
    constructor(

        firstname : string ,
        lastname : string ,
        usertype : number ,
        access : string , 
        username : string,
        status : boolean ,
        userId : number ,
        roleId : number,
        
        password : string,
        confpassword : string,
        teststr : string,
        selectedlocations : any[]
        

       
    ){

        this.firstname =firstname  ;
        this.lastname =lastname ;
        this.usertype =usertype ;
        this.access =access ; 
        this.username = username;
        this.status =status ;
        this.userId = userId;
        this.roleId = roleId ;
       
        this.password =password;
        this.confpassword = confpassword;
        this.teststr = teststr;
        this.selectedlocations = selectedlocations;
        
         
        
    }

}
